const getRangeBounds = (ranges) => {
  let min = Infinity
  let max = 0

  ranges.forEach((range) => {
    const [start, end] = range.split('-')
    const startNum = parseInt(start, 10)
    const endNum = end === 'n' ? Infinity : parseInt(end, 10)

    min = Math.min(min, startNum)
    max = Math.max(max, endNum)
  })

  return {
    min,
    max,
  }
}

export default getRangeBounds
